export interface UserConfig {
  oasToken: string;
  viewType: 'rep' | 'broker-dealer' | 'client';
  env: 'development' | 'stage' | 'production';
}

export interface ComponentProps {
  IsVoya: boolean;
  ComponentPath: string;
  Forms: {
    Id: string;
    Name: string;
  }[];
  UserConfig: {
    OasToken: string;
    ViewType: 'rep' | 'broker-dealer' | 'client';
    Env: 'development' | 'stage' | 'production';
  };
  Title: string;
  WorkflowType: 'NaoAgreementWorkflow' | 'FpAgreementWorkflow';
  CustomFormsData: {
    id: string;
    title: string;
    subTitle: string | null;
    collections: Collection[];
  };
}

interface Collection {
  id: string;
  title: string;
  subTitle: string | null;
  type: 'Account' | 'Household' | 'Contact' | null;
  status: Status;
  sessions: Session[];
}

interface Session {
  id: string;
  title: string;
  readOnly: boolean;
  status: Status;
}

export type Status = 'Completed' | 'Active';

export interface ApiService {
  save(): Promise<{ hasErrors: boolean }>;
  options(opt: FormRendererOptions): void;
  confirmUnsavedChangesIfDirty(acceptCallback: () => void, rejectCallback?: () => void): void;
}

export interface FormRendererOptions {
  showAsPreview: boolean;
}

export const LAYOUT_VARS = {
  pagePadding: 48,
  gridGap: 16,
  sidebarWidth: 360,
  minPageWidth: 1400,
};

export const PAGE_DESCRIPTION =
  'The selected form collection is shown on the left. Follow the steps on the right to enter all the required information.';
